import { useLiveQuery } from 'dexie-react-hooks';
import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { db } from '@/db/schema';

/** Progresso total de estudo (F15-T08). */
export function ProgressSummaryCard(): React.ReactElement | null {
  const progress = useLiveQuery(async () => {
    const total = await db.signs.filter((sign) => sign.active).count();
    if (total === 0) return null;

    const learned = await db.localSignState.filter((state) => state.learned).count();
    return { total, learned };
  }, []);

  // Sem nenhum sinal aprendido o cartão não agrega — a Home já convida a estudar.
  if (!progress || progress.learned === 0) return null;

  const percent = Math.round((progress.learned / progress.total) * 100);

  return (
    <Link
      to="/study"
      className="mt-4 block rounded-xl bg-slate-800 p-4 active:bg-slate-700"
    >
      <div className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 font-medium">
          <GraduationCap size={18} aria-hidden />
          Seu progresso
        </span>
        <span className="text-sm tabular-nums text-slate-300">
          {progress.learned} / {progress.total}
        </span>
      </div>

      <div
        className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-700"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${progress.learned} de ${progress.total} sinais aprendidos`}
      >
        <div className="h-full bg-emerald-400 transition-[width]" style={{ width: `${percent}%` }} />
      </div>

      <p className="mt-2 text-xs text-slate-400">{percent}% do glossário marcado como aprendido</p>
    </Link>
  );
}
